export const MASK_TEXT = 'MASKED';
export const urlQueryParams = {
    query: { name: 'query', isSensitive: true },
    suggestedQuestionId: { name: 'suggestedQuestionId', isSensitive: true },
    eurekaQuery: { name: 'eurekaQuery', isSensitive: true },
    eurekaUrl: {
        name: 'eurekaUrl',
        isSensitive: true,
        description: 'Eureka search url used for redirecting the user from fullscreen view new tab back to the Eureka SRP',
        dataType: 'string',
    },
};
function maskUrlSearchParams(urlSearchParams) {
    urlSearchParams.forEach((_v, paramKey) => {
        if (urlQueryParams[paramKey]?.isSensitive) {
            urlSearchParams.set(paramKey, MASK_TEXT);
        }
    });
    return decodeURIComponent(urlSearchParams.toString());
}
export function maskQueryParamsOnUrl(url) {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);
    const onlyHash = urlObj.hash.split('?')[0];
    const queryParamsInHash = new URLSearchParams(urlObj.hash.split('?')[1]);
    const searchStr = maskUrlSearchParams(searchParams);
    const queryStrInHash = maskUrlSearchParams(queryParamsInHash);
    urlObj.search = searchStr;
    if (onlyHash && queryStrInHash)
        urlObj.hash = `${onlyHash}?${queryStrInHash}`;
    return decodeURIComponent(urlObj.toString());
}
export function maskQueryParamsOnRelativePath(relativePath) {
    const [onlyPath, searchStr] = relativePath.split('?');
    const searchParams = new URLSearchParams(searchStr);
    const maskedSearchStr = maskUrlSearchParams(searchParams);
    return maskedSearchStr ? `${onlyPath}?${maskedSearchStr}` : onlyPath;
}
//# sourceMappingURL=url-query-param.js.map